import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";
import { useMediaQuery } from "../hooks/useMediaQuery";

type Props = {
  breakpoint?: number;
} & RangePickerProps;

type StyledProps = {
  isBelowWidth: boolean;
};

const StyledRangePicker = styled(DatePicker.RangePicker)<StyledProps>`
  width: 100%;
  .responsive-range-picker .ant-picker-panels {
    flex-direction: ${(props) => (props.isBelowWidth ? `column` : `row`)};
  }
`;

/**
 * A responsive RangePicker that switches to column layout on small screens. default (max-width: 675px)
 * You can set a custom breakpoint by passing a number to the `breakpoint` prop.
 */
export const ResponsiveRangePicker = observer((props: Props) => {
  const isBelowWidth = useMediaQuery(
    `(max-width: ${props.breakpoint ?? 675}px)`
  );

  return (
    <StyledRangePicker
      isBelowWidth={isBelowWidth}
      classNames={{
        popup: {
          root: "responsive-range-picker",
        },
      }}
      getPopupContainer={(trigger) => trigger}
      {...props}
    />
  );
});
